import React, { useState, useRef, useEffect } from 'react';
import './EditorDropdown.css';

const EditorDropdown = ({ options, value, onChange, placeholder, width, listWidth, listHeight, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div className={`editor-custom-dropdown ${className || ''}`} ref={dropdownRef} style={{ width }}>
      <div className="dropdown-label" onClick={() => setIsOpen(!isOpen)}>
        <span className="label-text">{selectedOption ? selectedOption.label : placeholder}</span>
        <i className={`fas fa-chevron-down dropdown-arrow ${isOpen ? 'open' : ''}`}></i>
      </div>
      {isOpen && (
        <div 
          className="dropdown-options-wrapper" 
          style={{ 
            width: listWidth || '100%', 
            maxHeight: listHeight || '300px' 
          }}
        >
          <ul className="dropdown-options">
            {options.map((option, idx) => (
              <li 
                key={idx} 
                className={`dropdown-item ${value === option.value ? 'selected' : ''} ${option.disabled ? 'disabled' : ''}`}
                onClick={() => {
                  if (option.disabled) return;
                  onChange(option.value);
                  setIsOpen(false);
                }}
                style={option.style}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default EditorDropdown;
